"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderTotal = void 0;
const getTotalOrderValue_1 = require("./getTotalOrderValue");
const getOrderTotal = (order, date) => {
    const total = (0, getTotalOrderValue_1.getTotalOrderValue)(order, date);
    return total;
};
exports.getOrderTotal = getOrderTotal;
